export default __webpack_public_path__ + "cocoa_doorbell_v5.8cd5994b.png";